const CLICKABLE = "button, a, [role=button], [role=menuitem], [role=tab], input[type=submit], input[type=checkbox]";

function selectorOf(el: Element): string {
  const tag = el.tagName.toLowerCase();
  if (el.id) return `${tag}#${el.id}`;
  const cls = [...el.classList].slice(0, 2).join(".");
  return cls ? `${tag}.${cls}` : tag;
}

export function describeClick(target: Element): { text: string; sel: string } | null {
  const el = target.closest(CLICKABLE);
  if (!el) return null;
  const text = (el.getAttribute("aria-label") || (el as HTMLElement).innerText || el.textContent || "")
    .replace(/\s+/g, " ").trim().slice(0, 120);
  return { text, sel: selectorOf(el) };
}

export function errorPayload(err: unknown, url: string) {
  const e = err instanceof Error ? err : new Error(typeof err === "string" ? err : "Non-error thrown");
  return { type: e.name || "Error", msg: e.message || String(err), stack: e.stack ?? null, url };
}
